export const toEnglishDigit = number => {
  console.log(number, typeof number);
  // return;
  var find = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
  var replace = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
  number.split('').forEach(n => {
    if (replace.some(arr => n === arr)) {
      return number;
    }
  });
  var replaceString = this;
  var regex;
  for (var i = 0; i < find.length; i++) {
    regex = new RegExp(find[i], 'g');
    number = number.replace(regex, replace[i]);
  }
  return number;
};
